//Get Case List
import { notification } from "antd";
import { get, post } from "../Utils/httpInterceptor";

export const getAllStateList = async (data) => {
  const response = await get(`/lendermgm/mapping/getAllStateList`);
  if (!response.data.error) {
    return response.data;
  } else {
    notification.error({ message: response.data.message });
    return response.data;
    return {
      data: [
        {
          stateName: "Andaman and Nicobar Islands",
          id: 1,
        },
        {
          stateName: "Madhya Pradesh",
          id: 2,
        },
      ],
      error: false,
      message: "State List Fetch Successfully",
      statusCode: "200",
    };
  }
};

export const getDealerList = async (data) => {
  const response = await post(`/lendermgm/mapping/getDealerList`, data);
  if (!response.data.error) {
    return response.data;
  } else {
    notification.error({ message: response.data.message });
    return response.data;
   
  }
};
export const getEmployeeList = async (data) => {
  const response = await post(`/lendermgm/mapping/getEmployeeList`,data);
  if (!response.data.error) {
    return response.data;
  } else {
    // notification.error({ message: response.data.message });
    return response.data;
    
  }
};
export const getEmployeeSuggestion = async (data) => {
  const response = await post(
    `/lendermgm/mapping/getEmployeeSuggestion`,
    data
  );
  if (!response.data.error) {
    return response.data;
  } else {
    notification.error({ message: response.data.message });
    return response.data;
  }
};

export const saveUpdateDealerFosMappingMaster = async (data) => {
  const response = await post(
    `/lendermgm/mapping/saveUpdateDealerFosMappingMaster`,
    data
  );
  if (!response.data.error) {
    notification.success({ message: response.data.message });
    return response.data;
  } else {
    notification.error({ message: response.data.message });
    return response.data;
  }
};
export const deleteDealerFosMapping = async (data) => {
  const response = await post(
    `/lendermgm/mapping/deleteDealerFosMapping`,
    data
  );
  if (!response.data.error) {
    notification.success({ message: response.data.message });
    return response.data;
  } else {
    notification.error({ message: response.data.message });
    return response.data;
  }
};

